import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiLegalDocument } from '@app/core/legal-documents/api-legal-documents';

@Component({
  selector: 'app-legal-document-preview',
  templateUrl: './legal-document-preview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
  ],
})
export class LegalDocumentPreviewComponent {
  public readonly legalDocument = input.required<ApiLegalDocument | null>();

}
